import { MedicalConsultConstants } from '../store/medicalConsult.constants'

export const medicalConsultSchemas = [
  {
    inputKey: MedicalConsultConstants.SET_PHYSICIAN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PHYSICIAN: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PHYSICIAN'],
    errorMessage: {
      properties: {
        SET_PHYSICIAN: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: MedicalConsultConstants.SET_OTHER_PHYSICIAN,
    isNumber: false,
    type: 'object',
    properties: {
      SET_OTHER_PHYSICIAN: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_OTHER_PHYSICIAN'],
    errorMessage: {
      properties: {
        SET_OTHER_PHYSICIAN: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: MedicalConsultConstants.SET_METHOD,
    isNumber: false,
    type: 'object',
    properties: {
      SET_METHOD: {
        type: 'string',

        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_METHOD'],
    errorMessage: {
      properties: {
        SET_METHOD: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: MedicalConsultConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: MedicalConsultConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const medicalConsultSecondsSchemas = [
  {
    inputKey: MedicalConsultConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
